import { memo, useCallback } from 'react'
import { Input } from '@shared/components/ui/input'
import { INPUTS, THRESHOLD } from './styles'

interface NumberRangeInputProps {
  fromValue: string
  toValue: string
  onFromChange: (value: string) => void
  onToChange: (value: string) => void
  fromPlaceholder?: string
  toPlaceholder?: string
  className?: string
  'aria-label'?: string
}

// Static configuration to avoid recreation
const DEFAULT_PLACEHOLDERS = {
  from: "1",
  to: "100",
} as const

const SEPARATOR_CLASSES = "flex-1 h-6 flex items-center justify-center pb-0.5" as const
const DEFAULT_WIDTH = THRESHOLD.fields.medium

export const NumberRangeInput = memo<NumberRangeInputProps>(function NumberRangeInput({ 
  fromValue, 
  toValue, 
  onFromChange, 
  onToChange,
  fromPlaceholder = DEFAULT_PLACEHOLDERS.from,
  toPlaceholder = DEFAULT_PLACEHOLDERS.to,
  className = DEFAULT_WIDTH,
  'aria-label': ariaLabel
}) {
  const handleFromChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onFromChange(e.target.value)
  }, [onFromChange])

  const handleToChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onToChange(e.target.value)
  }, [onToChange])

  return (
    <div 
      className={`${INPUTS.rangeContainer} ${className}`}
      role="group"
      aria-label={ariaLabel || "Number range input"}
    >
      <div className={INPUTS.rangeInputWrapper}>
        <Input
          type="number"
          value={fromValue}
          onChange={handleFromChange}
          className={INPUTS.range}
          placeholder={fromPlaceholder}
          aria-label="Range start"
        />
      </div>
      <div className={SEPARATOR_CLASSES}>
        <span className="text-muted-foreground text-sm" aria-hidden="true">-</span>
      </div>
      <div className={INPUTS.rangeInputWrapper}>
        <Input
          type="number"
          value={toValue}
          onChange={handleToChange}
          className={INPUTS.range}
          placeholder={toPlaceholder}
          aria-label="Range end"
        />
      </div>
    </div>
  )
})